export const API = 'https://us-central1-lippumaatti.cloudfunctions.net/api'



// WEBPACK FOOTER //
// ./globals.js